import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const BuyeasyHowToBuyButtonTranslations = wrapTranslationsSchema({
	name: 'BuyEasyHowToBuyButtonTranslations',
	title: 'How To Buy Button Translations',
	sanityId: 'buyeasy-storeHowToBuyButton',
	fields: {
		howToBuyButton: 'How to buy',
		fillYourCountry: 'Please, fill your country to use buying wizard',
		warningHeader: 'Before you go ...',
		warningMessageOnBehalfPattern:
			'You’re currently browsing as ###. Click “Update” to change your browsing values. Otherwise, click “Continue” to open the buying wizard in a new tab.',
		warningMessageCustomPattern:
			'You’re browsing with custom settings. Click “Update” to change your browsing values. Otherwise, click “Continue” to open the buying wizard in a new tab.',
		warningContinueButton: 'CONTINUE',
		warningUpdateButton: 'UPDATE',
		warningNoPropsHeader: 'Your user properties are missing.',
		warningNoPropsMessage:
			'You have not specified your user properties. Please do so now before continuing to the How to Buy guide.',
		warningNoPropsButton: 'Add User Properties',
	},
});
